// extracted by mini-css-extract-plugin
export default {"workRightTable":"table_workRightTable__JD3If"};